<script lang="ts">
	import { format } from 'svelte-i18n';
	// Design system
	import { Alert } from '@Shelly/shelly-design-system/index';
	// Components
	import TemplateToggleSettings from '../../Components/TemplateToggleSettings.svelte';
	// Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<TemplateToggleSettings
	class="mb-s"
	{device}
	setting="insert_handshake"
	title={$format('enable', { default: 'Enable' })}
/>

<Alert
	heading={$format('ev_charger_insert_handshake_info', {
		default:
			'When enabled, the charger will briefly start and stop charging on cable insert to complete the handshake required by some cars.',
	})}
/>
